import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/Home";
import ChartPage from "../pages/Chart";
import ExpensesPage from "../pages/Expenses";
import { PermissionRoute } from "../../../routes/PermissionRoute";
import CreateExpensePage from "../pages/Expenses/create";
import SettingsPage from "../pages/Settings";

export default function AccountingRoutes() {
  return(
    <Routes>
      <Route element={<PermissionRoute permission="accounting.home" />}>
        <Route path="home" element={<HomePage />} />
      </Route>

      <Route element={<PermissionRoute permission="accounting.expenses.view" />}>
        <Route path="expenses">
          <Route path="" element={<ExpensesPage />} />
          <Route path="create" element={<CreateExpensePage />} />
          <Route path="edit/:id" element={<CreateExpensePage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="accounting.expense_categories.view" />}>
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      <Route path="chart" element={<ChartPage />} />
    </Routes>
  );
}